import CloseIcon from '@mui/icons-material/Close';
import { LoadingButton } from '@mui/lab';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  useMediaQuery,
} from '@mui/material';
import CustomPopover from './CustomPopover';

// basic skeleton of a modal with cancel, confirm buttons, you pass in the entire content jsx as a prop
const CustomModal = ({
  open,
  onConfirm,
  onCancel,
  onClose,
  title,
  content,
  loading = false,
  disableConfirmAction = false,
  titlePopupContent,
  confirmText,
  cancelText,
  width = 450,
}) => {
  const mobiles = useMediaQuery('(max-width:540px)');

  return (
    <Dialog
      sx={{
        '& .MuiDialog-paper': {
          maxHeight: '80%',
          minWidth: mobiles ? 300 : width,
        },
      }}
      maxWidth="md"
      open={open}
    >
      <DialogTitle
        style={{
          fontFamily: 'Nunito',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          marginBottom: '20px',
        }}
      >
        {title}
        {titlePopupContent && (
          <CustomPopover
            type="hover"
            defaultIconStyle={{ marginLeft: '.2rem' }}
            customButton={null}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            {titlePopupContent}
          </CustomPopover>
        )}
        <span className="grow" />
        <IconButton onClick={onClose ? onClose : onCancel}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>{content}</DialogContent>

      <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
        {onConfirm && (
          <LoadingButton
            variant="contained"
            onClick={onConfirm}
            loading={loading}
            disabled={disableConfirmAction}
          >
            {confirmText || 'Confirm'}
          </LoadingButton>
        )}
        {onCancel && (
          <Button onClick={onCancel} sx={{ fontFamily: 'Nunito' }} disabled={loading}>
            {cancelText || 'Cancel'}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default CustomModal;
